import Slider6 from './Slider6'
export default Slider6
